import { priorityMeta } from "@/lib/api";

export default function PriorityBadge({ priority }) {
  const m = priorityMeta(priority);
  return (
    <span
      data-testid={`priority-${priority}`}
      className="badge-priority"
      style={{ background: m.bg, color: m.color, borderColor: m.color }}
    >
      {m.label}
    </span>
  );
}
